import { __decorate, __metadata } from "tslib";
import service from "@/services/api.service";
import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "..";
import { getTenantId } from "../helper";
import { TeamGridViewModel } from "../models/teams/teamList";
import { plainToClass } from "class-transformer";
import { ITeamDTO } from "../models/teams/addTeam";
import { Guid } from "guid-typescript";
import { TeamDetailViewModel } from "../models/teams/viewTeam";
import { IGroupSaveDTO } from "../models/teams/addGroup";
let TeamModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    let TeamModule = class TeamModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.addTeam = null;
            this.addGroup = null;
            this.teams = [];
            this.team = null;
            this.responseTeams = [];
            this.viewTeam = null;
            this.apiNode = "team";
        }
        async GetTeams() {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.get(url);
            if (data) {
                this.GetTeamList(plainToClass(TeamGridViewModel, data.teams));
                return data;
            }
        }
        async saveTeam(addTeam) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, addTeam);
            if (data) {
                return data;
            }
        }
        async DeleteTeamById(teamId) {
            var url = `${getTenantId()}/${this.apiNode}/` + teamId;
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        async DeleteGroupById(groupId) {
            var url = `${getTenantId()}/${this.apiNode}/group/` + groupId;
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        async saveGroup(addGroup) {
            var url = `${getTenantId()}/${this.apiNode}` + "/addgroup";
            let { data } = await service.post(url, addGroup);
            if (data) {
                return data;
            }
        }
        async GetTeamById(teamId) {
            var url = `${getTenantId()}/${this.apiNode}/` + teamId;
            let { data } = await service.get(url);
            if (data) {
                this.SetSelectedTeam(plainToClass(TeamGridViewModel, data.teams[0]));
                return data;
            }
        }
        async ViewTeamById(teamId) {
            var url = `${getTenantId()}/${this.apiNode}/` + teamId + `/getTeam`;
            let { data } = await service.get(url);
            if (data) {
                this.SetViewTeam(plainToClass(TeamDetailViewModel, data.viewTeam[0]));
                return data;
            }
        }
        GetTeamList(teams) {
            this.teams = teams;
        }
        SetSelectedTeam(team) {
            this.team = team;
        }
        SetViewTeam(viewTeam) {
            this.viewTeam = viewTeam;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], TeamModule.prototype, "GetTeams", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof ITeamDTO !== "undefined" && ITeamDTO) === "function" ? _b : Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], TeamModule.prototype, "saveTeam", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof Guid !== "undefined" && Guid) === "function" ? _d : Object]),
        __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
    ], TeamModule.prototype, "DeleteTeamById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof Guid !== "undefined" && Guid) === "function" ? _f : Object]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], TeamModule.prototype, "DeleteGroupById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof IGroupSaveDTO !== "undefined" && IGroupSaveDTO) === "function" ? _h : Object]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], TeamModule.prototype, "saveGroup", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_k = typeof Guid !== "undefined" && Guid) === "function" ? _k : Object]),
        __metadata("design:returntype", typeof (_l = typeof Promise !== "undefined" && Promise) === "function" ? _l : Object)
    ], TeamModule.prototype, "GetTeamById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_m = typeof Promise !== "undefined" && Promise) === "function" ? _m : Object)
    ], TeamModule.prototype, "ViewTeamById", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], TeamModule.prototype, "GetTeamList", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_o = typeof TeamGridViewModel !== "undefined" && TeamGridViewModel) === "function" ? _o : Object]),
        __metadata("design:returntype", void 0)
    ], TeamModule.prototype, "SetSelectedTeam", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_p = typeof TeamDetailViewModel !== "undefined" && TeamDetailViewModel) === "function" ? _p : Object]),
        __metadata("design:returntype", void 0)
    ], TeamModule.prototype, "SetViewTeam", null);
    TeamModule = __decorate([
        Module({ dynamic: true, store: store, name: "teams", namespaced: true })
    ], TeamModule);
    return TeamModule;
})();
export default getModule(TeamModule);
